import * as types from "../ActionTypes";
import { getTermsAndConditionsApi, getPrivacyPolicyApi, getCancellationRefundPolicyApi } from "../../apis/common/getLegalContentApi";

// ─── Terms & Conditions ───────────────────────────────────────────────────────

export const getTermsAndConditionsStart = () => ({
    type: types.GET_TERMS_AND_CONDITIONS_START,
});

export const getTermsAndConditionsSuccess = (data) => ({
    type: types.GET_TERMS_AND_CONDITIONS_SUCCESS,
    payload: data,
});

export const getTermsAndConditionsError = (error) => ({
    type: types.GET_TERMS_AND_CONDITIONS_ERROR,
    payload: error,
});

export const getTermsAndConditionsActionInitiate = () => {
    return async function (dispatch) {
        dispatch(getTermsAndConditionsStart());
        try {
            const res = await getTermsAndConditionsApi();
            const html = res.data?.html || res.data?.content || res.data || "";
            dispatch(getTermsAndConditionsSuccess(html));
            return { success: true, data: html };
        } catch (error) {
            const errorMessage =
                error.response?.data?.error ||
                error.response?.data?.message ||
                "Failed to fetch Terms & Conditions";
            console.error("getTermsAndConditionsError", error.response?.data);
            dispatch(getTermsAndConditionsError(errorMessage));
            return { success: false, error: errorMessage };
        }
    };
};

// ─── Privacy Policy ───────────────────────────────────────────────────────────

export const getPrivacyPolicyStart = () => ({
    type: types.GET_PRIVACY_POLICY_START,
});

export const getPrivacyPolicySuccess = (data) => ({
    type: types.GET_PRIVACY_POLICY_SUCCESS,
    payload: data,
});

export const getPrivacyPolicyError = (error) => ({
    type: types.GET_PRIVACY_POLICY_ERROR,
    payload: error,
});

export const getPrivacyPolicyActionInitiate = () => {
    return async function (dispatch) {
        dispatch(getPrivacyPolicyStart());
        try {
            const res = await getPrivacyPolicyApi();
            const html = res.data?.html || res.data?.content || res.data || "";
            dispatch(getPrivacyPolicySuccess(html));
            return { success: true, data: html };
        } catch (error) {
            const errorMessage =
                error.response?.data?.error ||
                error.response?.data?.message ||
                "Failed to fetch Privacy Policy";
            console.error("getPrivacyPolicyError", error.response?.data);
            dispatch(getPrivacyPolicyError(errorMessage));
            return { success: false, error: errorMessage };
        }
    };
};

// ─── Cancellation & Refund Policy ────────────────────────────────────────────

export const getCancellationRefundPolicyStart = () => ({
    type: types.GET_CANCELLATION_REFUND_POLICY_START,
});

export const getCancellationRefundPolicySuccess = (data) => ({
    type: types.GET_CANCELLATION_REFUND_POLICY_SUCCESS,
    payload: data,
});

export const getCancellationRefundPolicyError = (error) => ({
    type: types.GET_CANCELLATION_REFUND_POLICY_ERROR,
    payload: error,
});

export const getCancellationRefundPolicyActionInitiate = () => {
    return async function (dispatch) {
        dispatch(getCancellationRefundPolicyStart());
        try {
            const res = await getCancellationRefundPolicyApi();
            const html = res.data?.html || res.data?.content || res.data || "";
            dispatch(getCancellationRefundPolicySuccess(html));
            return { success: true, data: html };
        } catch (error) {
            const errorMessage =
                error.response?.data?.error ||
                error.response?.data?.message ||
                "Failed to fetch Cancellation & Refund Policy";
            console.error("getCancellationRefundPolicyError", error.response?.data);
            dispatch(getCancellationRefundPolicyError(errorMessage));
            return { success: false, error: errorMessage };
        }
    };
};
